import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '@app/store';
import {
  getRenalDetectRecommendation,
  setRenalDetectDetection,
  setRenalDetectNutritionRecommendationChoice,
} from './actions/renal-detect-recommendation.actions';
import { RenalDetectDetectionValues } from '../components/renal-detect-detection-form/renal-detect-detection-form';
import { RenalDetectChoiceValues } from '../components/renal-detect-choice-form/renal-detect-choice-form';
import { navigateBackToStep, setRenalDetectStep, startRenalDetect } from './actions/renal-detect-steps.actions';
import { RenalDetectStep } from '../renal-detect-step';
import { PanelSectionTypeEnum } from '@app/shared/utils';
import { selectDetection, selectRecommendation } from './selectors/renal-detect-recommendation.selectors';
import { Observable } from 'rxjs';
import { PetInfo, RenalDetectRecommendation } from '@app/core/models';
import { selectRenalDetectPetSummary, selectStep, selectSteps } from './selectors/renal-detect-steps.selectors';

@Injectable()
export class RenalDetectFacade {
  /** renal-detect-recommendation.selectors */
  public detection$: Observable<RenalDetectDetectionValues> = this.store$.pipe(select(selectDetection));
  public recommendation$: Observable<RenalDetectRecommendation> = this.store$.pipe(select(selectRecommendation));

  /** renal-detect-steps.selectors */
  public steps$: Observable<RenalDetectStep[]> = this.store$.pipe(select(selectSteps));
  public step$: Observable<RenalDetectStep> = this.store$.pipe(select(selectStep));
  public renalDetectPetSummary$: Observable<PetInfo> = this.store$.pipe(select(selectRenalDetectPetSummary));

  constructor(private readonly store$: Store<AppState>) {}

  /** renal-detect-recommendation.actions */
  setRenalDetectDetection(value: RenalDetectDetectionValues): void {
    this.store$.dispatch(setRenalDetectDetection({ value }));
  }

  setRenalDetectNutritionRecommendationChoice(value: RenalDetectChoiceValues): void {
    this.store$.dispatch(setRenalDetectNutritionRecommendationChoice({ value }));
  }

  getRenalDetectRecommendation(): void {
    this.store$.dispatch(getRenalDetectRecommendation());
  }

  /** renal-detect-steps.actions */
  startRenalDetect(): void {
    this.store$.dispatch(startRenalDetect());
  }

  setRenalDetectStep(value: RenalDetectStep, isNewPet?: boolean): void {
    this.store$.dispatch(setRenalDetectStep({ value, isNewPet }));
  }

  navigateBackToStep(value: PanelSectionTypeEnum): void {
    this.store$.dispatch(navigateBackToStep({ value }));
  }
}
